import { render } from "./TopSellingProducts.vue?vue&type=template&id=ae7e247a&ts=true"
import script from "./TopSellingProducts.vue?vue&type=script&lang=ts"
export * from "./TopSellingProducts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__